import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import sub from 'date-fns/sub';
import add from 'date-fns/add';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import './Reports.scss';
import AppSelect from '../../../shared/components/app-select/AppSelect';
import AppDatePicker from '../../../shared/components/app-date-picker/AppDatePicker';
import AppButton from '../../../shared/components/app-button/AppButton';
import {
  getUserAgentId,
  getStringFromLS,
} from '../../../shared/helper-utils/localStorage';
import {
  API_DATE_FORMAT,
  TODAY_DATE,
} from '../../../shared/constants/Constants';
import { formatDate, getNewDate } from '../../../shared/helper-utils/appUtils';
import AccountsPageHorizontalBar from '../accounts/AccountsPageHorizontalBar';
import { useAppContext } from '../../../saas/AppConfigWrapper';
import { APP_USER_AUTH } from '../../../saas/AppStorageStaticNames';
import AppAlert from '../../../shared/components/app-alert/AppAlert';

function Reports() {
  const intl = useIntl();
  const { appConfig } = useAppContext();
  const formattedMessage = (message) => {
    return intl.formatMessage({ id: message });
  };
  const [reportsType, setreportsType] = useState('FLIGHTSALES');
  const [fromDate, setFromDate] = useState(
    sub(getNewDate(TODAY_DATE), { days: 1 }),
  );
  const [toDate, setToDate] = useState(
    add(getNewDate(TODAY_DATE), { days: 1 }),
  );
  const [alert, setAlert] = useState(undefined);

  const REPORTS_TYPE = [
    { label: formattedMessage('flight_sales'), value: 'FLIGHTSALES' },
    { label: formattedMessage('flight_sales_pax'), value: 'FLIGHTSALESPAX' },
    {
      label: formattedMessage('flight_cancellation_report'),
      value: 'FLIGHTCANXREPORTUSER',
    },
    {
      label: formattedMessage('hotel_sales'),
      value: 'HOTELREPORTFORUSER',
    },
    {
      label: formattedMessage('hotel_cancellation_report'),
      value: 'HOTELCANXREPORT',
    },
    ...(appConfig?.hasBus === true
      ? [
          { label: formattedMessage('bus_sale_report'), value: 'BUSSALES' },
          {
            label: formattedMessage('bus_refund_report'),
            value: 'BUSCANXREPORTUSER',
          },
        ]
      : []),
    {
      label: formattedMessage('receipt_report'),
      value: 'RECEIPTREPORTFORUSER',
    },
    {
      label: formattedMessage('credit_debit_note_report'),
      value: 'CREDITDEBITNOTEREPORTFORUSER',
    },
    {
      label: formattedMessage('fund_transfer_reversal_report'),
      value: 'FUNDTRANSFERREVERSALREPORTFORUSER',
    },
    { label: formattedMessage('tds_report'), value: 'TDSREPORTFORUSER' },
  ];

  const handleGetReports = () => {
    if (fromDate > toDate) {
      setAlert({
        variant: 'error',
        title: 'Sales Reports',
        description: 'From Date should not be greater than To Date',
      });
      return;
    }

    const agentId = getUserAgentId();
    const userAuth = getStringFromLS(APP_USER_AUTH);
    const fromdate = formatDate(fromDate, API_DATE_FORMAT);
    const todate = formatDate(toDate, API_DATE_FORMAT);
    let link = '';
    if (
      reportsType === 'FLIGHTSALES' ||
      reportsType === 'BUSSALES' ||
      reportsType === 'HOTELCANXREPORT'
    ) {
      link = `${appConfig?.appMainUrl}v2dispatch.jsp?sessiontoken=${userAuth}&opid=RP046&actioncode=SALESREPORT&agentid=${agentId}&period=PERIODIC&fromdate=${fromdate}&todate=${todate}&responseformat=excel&txtype=${reportsType}&format=html`;
    } else if (reportsType === 'FLIGHTSALESPAX') {
      link = `${appConfig?.appMainUrl}v2dispatch.jsp?sessiontoken=${userAuth}&opid=RP023&actioncode=GETPAXWISEFLIGHTREPORT&agentid=${agentId}&period=PERIODIC&fromdate=${fromdate}&todate=${todate}&responseformat=excel&txtype=${reportsType}&format=html`;
    } else {
      link = `${appConfig?.appMainUrl}v2dispatch.jsp?sessiontoken=${userAuth}&opid=RP056&actioncode=${reportsType}&agentid=${agentId}&period=PERIODIC&fromdate=${fromdate}&todate=${todate}&responseformat=excel&format=html`;
    }
    if (reportsType === 'HOTELREPORTFORUSER') {
      link += '&supplierid=all&payment_mode=all&booking_status=all';
    }
    const element = document.createElement('a');
    element.href = link;
    element.target = '_blank';
    element.download = `Sales_Reports.xls`;
    element.click();
  };
  return (
    <section className="reports-page py-4">
      {alert && (
        <AppAlert
          variant="error"
          showIcon
          onHide={() => setAlert(undefined)}
          title={alert.title}
          description={alert.description}
        />
      )}
      <AccountsPageHorizontalBar selectedPage="reports" />
      <section className="reports-page_container">
        <div className="reports-page_header">
          {formattedMessage('daily_periodic_sales')}
        </div>
        <div className="reports-page_content p-3">
          <Row className="spacing-8 gap-3">
            <Col xs={12} lg={3} md={3} sm={6}>
              <AppSelect
                name="reportsType"
                className="app-select"
                placeholder=""
                label={formattedMessage('select_type')}
                selectedValue={reportsType}
                options={REPORTS_TYPE}
                onSelect={(dataObj) => {
                  setreportsType(dataObj.value);
                }}
                isClearable={false}
              />
            </Col>
            <Col xs={12} lg={3} md={3} sm={6}>
              <AppDatePicker
                selectedDate={fromDate}
                type="date"
                name="fromDate"
                placeholder=""
                label={formattedMessage('from_date')}
                customClassName="position-relative"
                labelClassName="landing-datepicker-label"
                onChange={(date) => setFromDate(date)}
              />
            </Col>
            <Col xs={12} lg={3} md={3} sm={6}>
              <AppDatePicker
                selectedDate={toDate}
                type="date"
                name="toDate"
                placeholder=""
                label={formattedMessage('to_date')}
                labelClassName="landing-datepicker-label"
                customClassName="position-relative"
                onChange={(date) => setToDate(date)}
              />
            </Col>

            <Col
              xs={6}
              lg={2}
              md={2}
              sm={6}
              className="d-flex align-items-center"
            >
              <AppButton
                variant="secondary"
                btnText={formattedMessage('get_report_btn')}
                onClick={handleGetReports}
              />
            </Col>
          </Row>
        </div>
      </section>
    </section>
  );
}

export default Reports;
